<template>
  <div class="component">
    <div class="main-title">
      <div class="square"></div>
      <div class="title-content">工作概览</div>
    </div>
    <div class="main-content">
      <portrait-labels :labelList="componentData.workOverview"></portrait-labels>
      <div class="sub" v-if="componentData.workExperience!=null&&componentData.workExperience.length>0">
        <div class="sub-title">
          工作经历
        </div>
        <div class="sub-content">
          <el-timeline>
            <el-timeline-item
                v-for="item in componentData.workExperience"
            >
              <div class="timeline-content">
                <div class="timeline-title">{{ item.timeAxis }}</div>
                <div class="timeline-detail">
                  <div class="slotInfos" v-if="trimArray(item.slotInfo) && trimArray(item.slotInfo).length">
                    <div class="slotInfo" v-for="(slotInfo,slotInfoIndex) in trimArray(item.slotInfo)">
                      {{ slotInfo }}
                      <el-divider v-if="slotInfoIndex !== (item.slotInfo.length-1)"
                                  direction="vertical"></el-divider>
                    </div>

                  </div>
                  <portrait-labels :labelList="item.slotLabel"></portrait-labels>
                  <fold-module v-if="item.slotDetail && item.slotDetail.length" :slotDetail="item.slotDetail"></fold-module>

                </div>
              </div>
            </el-timeline-item>
            <div class="timeAxis">
              <el-timeline-item
              ></el-timeline-item>
            </div>
          </el-timeline>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabWork",
  props: {
    componentData: [Object, Array]
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    trimArray(array) {
      let result = []
      this.$emit("trimArray", array, val => {
        result = val
      })
      return result
    }
  },
}
</script>

<style lang="less">
</style>
